import { Box, Typography } from "@mui/material";
import { DriverNo } from "generated/sales";
import { useFormContext, useWatch } from "react-hook-form";
import { IDeliveryTrip } from "types/Logistic/deliveryTrip";
import { numberFormatter } from "utils/Formatter/Global";

type Props = {
  source?: "driver1" | "driver2" | "all";
  noBg?: boolean;
};

const PostDiscountAmount = ({ source = "all", noBg }: Props) => {
  const { control } = useFormContext<IDeliveryTrip>();

  const expensesList = useWatch({
    control,
    name: "expenses_list",
  }) ?? [];

  const total = (() => {
    if (source === "driver1") {
      return expensesList
        .filter((x) => (x.driver_no ?? DriverNo.Primary) === DriverNo.Primary)
        .reduce((sum, item) => sum + (item.pre_vat_amount ?? 0), 0);
    }

    if (source === "driver2") {
      return expensesList
        .filter((x) => x.driver_no === DriverNo.Secondary)
        .reduce((sum, item) => sum + (item.pre_vat_amount ?? 0), 0);
    }

    return expensesList.reduce(
      (sum, item) => sum + (item.pre_vat_amount ?? 0),
      0
    );
  })();

  return (
    <Box
      sx={{
        my: 1,
        display: "flex",
        alignItems: "center",
        gap: 3,
        height: "2rem",
      }}
      bgcolor={noBg ? undefined : "secondary.main"}
      maxWidth={461}
      marginLeft="auto"
      justifyItems="flex-end"
      borderRadius={1}
    >
      <>
        <Typography
          color={"primary.main"}
          textAlign={"right"}
          flex={2}
          minWidth={50}
          fontWeight={600}
        >
          รวม
        </Typography>
        <Typography
          color={"primary.main"}
          sx={{ minWidth: 150, textAlign: "right", mr: 2, flex: 1 }}
          fontWeight={600}
        >
          {numberFormatter(total)}
        </Typography>
      </>
      <Typography color={"primary.main"} sx={{ ml: 2.5, mr: 4 }} fontWeight={600}>
        บาท
      </Typography>
    </Box>
  );
};

export default PostDiscountAmount;
